import { render, staticRenderFns } from "./UniversalForm.vue?vue&type=template&id=ece28c60&scoped=true"
import script from "./UniversalForm.vue?vue&type=script&lang=js"
export * from "./UniversalForm.vue?vue&type=script&lang=js"
import style0 from "./UniversalForm.vue?vue&type=style&index=0&id=ece28c60&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ece28c60",
  null
  
)

export default component.exports